import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/payments/')({
  beforeLoad: () => {
    throw redirect({ to: '/payments' })
  },
})
